import { render, staticRenderFns } from "./ImzaKimlikSeridi.vue?vue&type=template&id=cd0767c2"
import script from "./ImzaKimlikSeridi.vue?vue&type=script&lang=ts"
export * from "./ImzaKimlikSeridi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports